<div class="form-group-custom">
  <label for="inputCruiseHarbour" class="input-group-zeus__label">Porto</label>
  <div
    class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent"
    id="cruiseHarbour-select"
  >
    <ng-select
      [items]="
        (cruisePrefetch$ | async)?.harbours
          | formatPrefetch : 'harbours'
          | async
          | ngSelectSortBy : 'Name'
      "
      [loading]="!(cruisePrefetch$ | async)"
      [searchable]="(isMobile$ | async) ? false : true"
      [dropdownPosition]="
        (isMobile$ | async) && (isWidget$ | async) ? 'top' : 'auto'
      "
      placeholder="Seleziona Porto"
      bindLabel="Name"
      bindValue="Id"
      (change)="selectHarbour($event)"
      id="inputCruiseHarbour"
      class="form-control-custom"
      [(ngModel)]="selectedHarbourInner"
    >
    </ng-select>
    <div
      class="input-group-custom__prepend input-group-custom__prepend--transparent"
    >
      <span
        class="input-group-custom__icon input-group-custom__icon--transparent"
        id="basic-addon3"
        ><i class="icon-pin"></i
      ></span>
    </div>
  </div>
</div>
